module.exports = __webpack_public_path__ + "img/standard1.78c6dfc.png";